import { createSelector } from '@reduxjs/toolkit';

import { selectAvailableBanks } from './selectAvailableBanks';

export interface IBankPartner {
  id: number;
  title: string;
  wideLogoUrlLight?: string | null;
  wideLogoUrlDark?: string | null;
}

export const selectBankPartners = createSelector(selectAvailableBanks, banks =>
  banks.reduce<IBankPartner[]>((acc, { id, title, wideLogoUrlLight, wideLogoUrlDark }) => {
    if (wideLogoUrlLight || wideLogoUrlDark) {
      acc.push({ id, title, wideLogoUrlLight, wideLogoUrlDark });
    }

    return acc;
  }, []),
);
